import Vue from 'vue';

import UI from '@/ui';

Vue.use(UI);
